/** Copy of the cashflow page (Operations), ported from VentaHub. */
export const cashflow = {
  title: 'Cashflow',
  description: 'What is expected in and out, by the week it falls due.',
  empty: 'Nothing falls due in this window',
  emptyHint: 'Settled and voided invoices are not counted.',
  overdue: 'Overdue',
  weekOf: 'Week of {{date}}',
  open: 'Show the invoices for {{row}}',
  filters: {
    warehouse: 'Warehouse',
    retailer: 'Retailer',
    vendor: 'Vendor',
    provider: 'Service provider',
    dates: 'Due',
    opening: 'Opening balance',
    openingHint: 'Press Enter to apply.',
    openingCurrency: 'Currency',
    currencyAuto: 'Auto',
  },
  balanceHelp:
    'Cash expected on hand after this row: the opening balance plus every net so far, in this currency. Below zero is a cash gap.',
  columns: {
    week: 'Week',
    currency: 'Currency',
    inflow: 'In',
    outflow: 'Out',
    net: 'Net',
    balance: 'Balance',
  },
  documents: {
    description: 'The unsettled invoices counted in this row, earliest due first.',
    firstOf: 'The first {{shown}} of {{total}} invoices, earliest due first.',
    empty: 'No invoices in this row.',
    dueFrom_one: '{{date}} + {{count}} day',
    dueFrom_other: '{{date}} + {{count}} days',
    kind: {
      sales_invoice: 'Sales invoice',
      vendor_invoice: 'Vendor invoice',
      sp_invoice: 'Service provider invoice',
    },
    columns: {
      kind: 'Type',
      number: 'Invoice number',
      party: 'Party',
      due: 'Due',
      unsettled: 'Unsettled',
    },
  },
} as const
